
function create_shader(gl, type, source) {
    let shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    let success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

    if (success) {
        return shader;
    }

    console.log(gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
}

function create_program(gl, vertex_shader, fragment_shader) {
    let program = gl.createProgram();
    gl.attachShader(program, vertex_shader);
    gl.attachShader(program, fragment_shader);
    gl.linkProgram(program);

    let success = gl.getProgramParameter(program, gl.LINK_STATUS);

    if (success) {
        return program;
    }

    console.log(gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
}


// @TODO(Grey): I need to put these things on the state object:
/*
    position_attribute_location
    position_buffer
    index_buffer

    vertexAttribPointer(index, size, type, normalized, stride, offset)
    position_attribute_size
    position_attribute_type
    position_attribute_normalized
    position_attribute_stride // zero defaults to sizeof type
    position_attribute_offset

    color_uniform_location
    time_uniform_location

    index_buffer_count
    index_buffer_type
    index_buffer_offset
*/

function update(state) {
    let width = state.canvas.clientWidth;
    let height = state.canvas.clientHeight;

    if (state.canvas.width !== width || state.canvas.height !== height) {
        state.canvas.width = width;
        state.canvas.height = width;
    }

    state.ctx.viewport(0, 0, state.ctx.drawingBufferWidth, state.ctx.drawingBufferHeight);

    state.ctx.clearColor(1, 1, 1, 1);
    state.ctx.clear(state.ctx.COLOR_BUFFER_BIT);

    state.ctx.useProgram(state.program);
    state.ctx.bindVertexArray(state.vertex_array);

    state.ctx.uniform4fv(state.uniforms.color, [0.98, 0.95, 1.0, 1.0]);
    state.ctx.uniform1f(state.uniforms.time, performance.now());
    state.ctx.uniform1i(state.uniforms.debug, state.debug ? 1 : 0);

    state.ctx.drawElements(state.ctx.TRIANGLES, state.number_of_elements, state.ctx.UNSIGNED_SHORT, 0);

    requestAnimationFrame(update.bind(this, state));
}


function init() {
    let state = {
        canvas: null,
        ctx: null,
        debug: false,

        // @NOTE(Grey): These are my draw state things that should be bundled
        program: null,
        vertex_array: null,
        number_of_elements: null,
        uniforms: {
            color: null,
            time: null,
            debug: null,
        }
    };

    state.canvas = document.querySelector('.js-FuzzyBlobs');
    if (state.canvas) {
        state.ctx = state.canvas.getContext("webgl2");
    }

    if (!state.ctx) {
        return;
    }

    let vertex_shader_source = `#version 300 es
        in vec4 a_position;

        out vec2 v_coord;

        void main() {
            v_coord = a_position.xy;

            gl_Position = a_position;
        }
    `;
    let fragment_shader_source = `#version 300 es
        precision mediump float;

        uniform vec4 u_color;
        uniform float u_time;
        uniform int u_debug;

        in vec2 v_coord;

        out vec4 frag_color;

        #define PI radians(180.0)

        float ndot(vec2 a, vec2 b ) { return a.x*b.x - a.y*b.y; }

        // 2D Random
        float random (in vec2 st) {
            return fract(sin(dot(st.xy,
                                 vec2(12.9898,78.233)))
                         * 43758.5453123);
        }

        // 2D Noise based on Morgan McGuire @morgan3d
        // https://www.shadertoy.com/view/4dS3Wd
        float noise (in vec2 st) {
            vec2 i = floor(st);
            vec2 f = fract(st);

            // Four corners in 2D of a tile
            float a = random(i);
            float b = random(i + vec2(1.0, 0.0));
            float c = random(i + vec2(0.0, 1.0));
            float d = random(i + vec2(1.0, 1.0));

            // Smooth Interpolation
            // Cubic Hermine Curve.  Same as SmoothStep()
            vec2 u = f*f*(3.0-2.0*f);

            // Mix 4 coorners percentages
            return mix(a, b, u.x) +
                    (c - a)* u.y * (1.0 - u.x) +
                    (d - b) * u.x * u.y;
        }

        float sdCircle( in vec2 p, in float r )
        {
            return length(p)-r;
        }

        float sdBox( in vec2 p, in vec2 b )
        {
            vec2 d = abs(p)-b;
            return length(max(d,0.0)) + min(max(d.x,d.y),0.0);
        }

        float sdOrientedBox( in vec2 p, in vec2 a, in vec2 b, float th )
        {
            float l = length(b-a);
            vec2  d = (b-a)/l;
            vec2  q = p-(a+b)*0.5;
                  q = mat2(d.x,-d.y,d.y,d.x)*q;
                  q = abs(q)-vec2(l*0.5,th);
            return length(max(q,0.0)) + min(max(q.x,q.y),0.0);
        }

        float sdRhombus( in vec2 p, in vec2 b )
        {
            p = abs(p);

            float h = clamp( ndot(b-2.0*p,b)/dot(b,b), -1.0, 1.0 );
            float d = length( p-0.5*b*vec2(1.0-h,1.0+h) );

            return d * sign( p.x*b.y + p.y*b.x - b.x*b.y );
        }

        float sdEquilateralTriangle( in vec2 p, in float r )
        {
            const float k = sqrt(3.0);
            p.x = abs(p.x) - r;
            p.y = p.y + r/k;
            if( p.x+k*p.y>0.0 ) p = vec2(p.x-k*p.y,-k*p.x-p.y)/2.0;
            p.x -= clamp( p.x, -2.0*r, 0.0 );
            return -length(p)*sign(p.y);
        }

        float merge(in float a, in float b)
        {
            return min(a, b);
        }

        float intersect(in float a, in float b)
        {
            return max(a, b);
        }

        float subtract(in float a, in float b)
        {
            return intersect(a, -b);
        }

        // @NOTE(Grey): This is a specific shaping function
        // for the gradient falloff
        float roof(in float x)
        {
            return pow(min(cos(PI * x / 2.0), 1.0 - abs(x)), 1.5);
        }


        const vec3 pink01   = vec3(0.96, 0.64, 0.88);
        const vec3 purple01 = vec3(0.70, 0.46, 0.94);
        const vec3 blue01   = vec3(0.43, 0.79, 0.97);
        const vec3 green01  = vec3(0.49, 0.89, 0.41);
        const vec3 yellow01 = vec3(1.00, 0.87, 0.20);
        const vec3 red01    = vec3(1.00, 0.50, 0.50);

        const vec3 pink02   = vec3(1.00, 0.95, 1.00);
        const vec3 purple02 = vec3(1.00, 0.95, 1.00);
        const vec3 blue02   = vec3(0.93, 0.98, 1.00);
        const vec3 green02  = vec3(0.92, 1.00, 0.90);
        const vec3 yellow02 = vec3(1.00, 0.98, 0.85);
        const vec3 red02    = vec3(1.00, 0.95, 0.95);


        void main() {
            float t = u_time * 0.00025;
            vec3 col = vec3(1.0);

            const int n = 4;
            for (int i = 0; i < n; i += 1) {
                float a = (float(i) / float(n)) * PI * 2.0;
                vec2 pos = vec2(sin(t + a), cos(t + a)) * 0.425 + vec2(0.0, 0.75);
                float rad = (1.0 + noise(v_coord + t + a) / 2.0) * 0.40;
                float d = sdCircle(v_coord + pos, rad);

                vec3 circle_color = pink01;

                if (i == 0) { circle_color = pink01;   }
                if (i == 1) { circle_color = purple01; }
                if (i == 2) { circle_color = green01;  }
                if (i == 3) { circle_color = yellow01; }
                if (i == 4) { circle_color = blue01;   }
                if (i == 5) { circle_color = red01;    }

                col = mix(col, circle_color, d < 0.0 ? 1.0 - roof(d) : 0.0);

                if (u_debug > 0) {
                    col = mix(col, circle_color, d < 0.0 ? 1.0 - d : 0.0);
                }
            }

            // Mask with white
            // float mask_distance = sdRhombus(v_coord, vec2(1.0, 1.0));
            // mask_distance = subtract(mask_distance, sdRhombus(v_coord - vec2(0.0, 1.05), vec2(1.0, 1.0)));
            // col = mix(col, vec3(1.0, 1.0, 1.0), step(0.0, mask_distance));

            frag_color = vec4(col, 1.0);
        }
    `;

    let vertex_shader = create_shader(
        state.ctx,
        state.ctx.VERTEX_SHADER,
        vertex_shader_source
    );
    let fragment_shader = create_shader(
        state.ctx,
        state.ctx.FRAGMENT_SHADER,
        fragment_shader_source
    );

    state.program = create_program(state.ctx, vertex_shader, fragment_shader);


    state.vertex_array = state.ctx.createVertexArray();
    state.ctx.bindVertexArray(state.vertex_array);

    // @TODO(Grey): Do all this wiring up in a more automatic way
    let position_attribute_location = state.ctx.getAttribLocation(state.program, "a_position");

    state.uniforms.color = state.ctx.getUniformLocation(state.program, "u_color");
    state.uniforms.time = state.ctx.getUniformLocation(state.program, "u_time");
    state.uniforms.debug = state.ctx.getUniformLocation(state.program, "u_debug");

    let position_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, position_buffer);

    let positions = [
        -1.0, -1.0,
         1.0, -1.0,
        -1.0,  1.0,
         1.0,  1.0,
    ];
    state.ctx.bufferData(
        state.ctx.ARRAY_BUFFER,
        new Float32Array(positions),
        state.ctx.STATIC_DRAW
    );

    let index_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ELEMENT_ARRAY_BUFFER, index_buffer);

    let indices = [
        0, 1, 2,  1, 3, 2,
    ];
    state.ctx.bufferData(
        state.ctx.ELEMENT_ARRAY_BUFFER,
        new Uint16Array(indices),
        state.ctx.STATIC_DRAW
    );

    state.number_of_elements = 6;

    state.ctx.enableVertexAttribArray(position_attribute_location);
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, position_buffer);
    state.ctx.bindBuffer(state.ctx.ELEMENT_ARRAY_BUFFER, index_buffer);

    state.ctx.vertexAttribPointer(position_attribute_location, 2, state.ctx.FLOAT, false, 0, 0);

    state.ctx.bindVertexArray(null);

    window.addEventListener('keyup', function(event) {
        if (event.key === 'b') {
            state.debug = !state.debug;
        }
    })

    update(state);
}

init();
